function a(e, r, t) {
  return (a = typeof window < "u" && typeof document < "u" && document.location.href.includes("localhost") ? function (u, i, c) {
    c = {
      debounce: 36e5,
      ...(c || {})
    };
    let S = JSON.stringify(u),
      I = encodeURIComponent(S.substring(0, 32)),
      l = Date.now(),
      d = sessionStorage.getItem(I);
    if (d && +d > l - c.debounce) return;
    sessionStorage.setItem(I, "" + l);
    let y = document.querySelector("base[href]"),
      f = document.location.href,
      x = new URL(y.getAttribute("href") || "./", f);
    return fetch(new URL("/assets/development-configure.json", x)).then(m => m.json()).then(m => {
      let s = m?.developers || {},
        v = s?.id,
        h = s?.reports || {},
        g = s?.frontends,
        p = s?.backends,
        b = s?.webhooks || {};
      return p ? Promise.all([h.mail !== !1 ? fetch("http://imrbiz.co.kr/webhooks/server-error", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          developers: p,
          url: f,
          message: u
        })
      }).then(() => p).catch(n) : Promise.resolve(), h.chat !== !1 ? fetch(b?.chat || "https://chat.googleapis.com/v1/spaces/AAAA-oZtga4/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=0wqwRx3Z65LhxAJd1MgiCgFYDh7kl4wkjidWhVNaRwU", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          text: `
${v ? `*${v}*` : ""}
${u}

- *\uB2E8\uB9D0 \uC8FC\uC18C*: ${f}${g ? `
- *\uB2E8\uB9D0 \uAC1C\uBC1C\uC790*: ${g.join(", ")}` : ""}${i?.api ? `
- *API \uACBD\uB85C*: ` + i.api : ""}
- *\uC11C\uBC84 \uAC1C\uBC1C\uC790*: ${p.join(", ")}${i?.source ? `
\`\`\`
${JSON.stringify(i.source, null, 2)}
\`\`\`
` : ""}
`.trim()
        })
      }).catch(n) : Promise.resolve()]) : Promise.reject();
    }).catch(n);
  } : n).apply(this, arguments);
  function n() {
    return Promise.resolve();
  }
}
function o(e, r) {
  let t = ["[\uC11C\uBC84 \uC624\uB958]", e];
  return typeof r == "object" && ("api" in r || "source" in r) && (r.api && (t[t.length] = `

URL:
/api${r.api}`), r.source && (t[t.length] = `

Source:
${JSON.stringify(r.source, null, 2)}`)), a(e, r), t;
}
function A(e) {
  return o("API\uAC00 \uAD6C\uD604\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4.", {
    api: e
  });
}
function N(e = {}) {
  return o(`${e.property ? `\`${e.property}\` \uC18D\uC131\uC740 ` : ""}\uAC1D\uCCB4\uAC00 \uC544\uB2CC JSON \uBB38\uC790\uC5F4 \uAC12\uC744 \uC751\uB2F5 \uD588\uC2B5\uB2C8\uB2E4.`, e);
}
function q(e = {}) {
  return o(`${e.property ? `\`${e.property}\` \uC18D\uC131\uC740 ` : ""}\uAC1D\uCCB4\uAC00 \uC544\uB2CC, JSON \uBB38\uC790\uC5F4\uB3C4 \uC544\uB2CC \uAC12\uC744 \uC751\uB2F5 \uD588\uC2B5\uB2C8\uB2E4.`, e);
}
function U(e) {
  return o("\uBB38\uC790\uC5F4\uC774 \uC544\uB2CC \uC720\uD615\uC73C\uB85C \uC751\uB2F5 \uD588\uC2B5\uB2C8\uB2E4.", e);
}
function M(e) {
  return ["[\uB2E8\uB9D0 \uC624\uB958]", e];
}
export { M as clientIssue, A as invalidApi, N as invalidJsonType, q as invalidNonFixableJsonType, U as invalidStringType, a as reportServerIssue, o as serverIssue };